<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <span v-on="{ ...tooltip }">
          <v-btn
            class="mr-1"
            small
            color="primary"
            :disabled="disabled"
            v-on:click="() => (dialog = !dialog)"
            icon
          >
            <v-icon>mdi-book-open-outline</v-icon>
          </v-btn>
        </span>
      </template>
      <span>{{ $t("cards.CardActionLog") }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <v-card width="1000">
        <v-card-title>
          <span class="headline">{{ $t("cards.CardActionLog") }}</span>
          <span v-if="card" style="color: grey; margin-left: 10px"> (card ID: {{ card.cardId }}) </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row style="height: 10%">
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-if="!disabled"
                  v-model="card.cardholder"
                  :label="this.$t('cards.cardholder')"
                  disabled
                />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-if="!disabled"
                  v-model="pan"
                  :label="this.$t('cards.pan')"
                  disabled
                />
              </v-col>
              <v-col
                id="tableCol"
                style="overflow-y: auto;max-height: 400px"
                cols="12"
                sm="12"
                md="12"
              >
                <v-data-table
                  :headers="headers"
                  :items="logs"
                  :item-key="'logRecordId'"
                  disable-pagination
                  :no-data-text="$t('logs.NoLogs')"
                  hide-default-footer
                  fixed-header
                  height="100%"
                >
                  <template v-slot:item.objects="{ item }">
                    <span v-if="item.objects.length === 1"></span>
                    <span
                      v-else-if="
                        item.objects.length === 2 &&
                          !!item.objects[1].deviceName
                      "
                    >
                      {{ item.objects[1].deviceName }}
                    </span>
                  </template>

                  <template v-slot:item.logDateTime="{ item }">
                    {{ item.logDateTime | formattedDate }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="height: 10%">
          <v-row>
            <v-col cols="3"> </v-col>
            <v-col cols="6">
              <v-layout justify-center>
                <v-btn
                  id="sizeBtn"
                  class="mr-1"
                  color="primary"
                  icon
                  v-on:mousedown="(ev) => mouseDown(ev)"
                >
                  <v-icon medium>mdi-arrow-split-horizontal</v-icon>
                </v-btn>
              </v-layout>
            </v-col>
            <v-col cols="3">
              <v-layout justify-end>
                <v-btn color="blue darken-1" text @click="dialog = false"
                  >{{ $t("Close") }}
                </v-btn>
              </v-layout>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import formatDate from '@/services/dateFormatter';
import DragForm from '@/components/Forms/DragForm.vue';

export default {
  components: {
    DragForm,
  },
  name: 'CardLogsDialog',
  props: {
    card: {
      type: Object,
      defaultItem: {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      logs: [],
      pan: String,

      positionDiff: 0,
      tableColElem: null,
      sizeBtnElem: null,
      sizeBtnClicked: false,
    };
  },
  filters: {
    formattedDate(dateString) {
      return formatDate(dateString);
    },
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
      else {
        this.getData();
      }
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('logs.LogMessage'),
          value: 'logMessage',
          sortable: false,
        },
        {
          text: this.$t('logs.DateTime'),
          value: 'logDateTime',
          sortable: false,
        },
        { text: this.$t('logs.Name'), value: 'objects', sortable: false },
        { text: this.$t('logs.Username'), value: 'name', sortable: false },
      ];
    },
  },
  mounted() {
    document.addEventListener('mouseup', this.mouseUp);
    document.addEventListener('mousemove', this.mouseMove);
  },
  methods: {
    clear() {
      this.tableColElem = null;
      this.sizeBtnElem = null;
    },
    mouseUp() {
      this.sizeBtnClicked = false;
    },
    mouseDown(ev) {
      if (this.tableColElem === null) {
        this.tableColElem = document.getElementById('tableCol');
        this.sizeBtnElem = document.getElementById('sizeBtn');
      }

      this.sizeBtnClicked = true;

      var elemY = this.sizeBtnElem.getBoundingClientRect().top;
      this.positionDiff = elemY - ev.pageY;
    },
    mouseMove(ev) {
      if (!this.sizeBtnClicked) return;

      var height = this.tableColElem.offsetHeight;

      var elemY = this.sizeBtnElem.getBoundingClientRect().top;
      var mouseBtnDiff = elemY - ev.y;
      var diff = this.positionDiff - mouseBtnDiff;

      height = height + diff;

      this.tableColElem.style.maxHeight = height + 'px';
      this.tableColElem.style.height = height + 'px';
    },

    async getData() {
      this.getLogs();
      this.getPan();
    },

    getLogs() {
      this.$axios.logs
        .getByCardId(this.card.cardId)
        .then((response) => response.data)
        .then((json) => {
          this.logs = json.logs;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPan() {
      this.$axios.logs
        .getPanByCardId(this.card.cardId)
        .then((response) => response.data)
        .then((json) => (this.pan = json.pan))
        .catch((error) => {
          console.error(error);
          this.pan = '';
        });
    },
  },
};
</script>
